import { REFERRAL_CODE } from "constants/storageKeys";
import { useEffect } from "react";

const REFERRAL_QUERY_PARAM = "ref";

export const useStoreReferralCode = (): void => {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get(
      REFERRAL_QUERY_PARAM
    );
    if (!code) return;

    localStorage.setItem(REFERRAL_CODE, JSON.stringify(code));
  }, []);
};
